/* A question before something that cannot be undone (see ask.tsx), over every screen. */

.ask {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(255, 246, 235, 0.55);
  backdrop-filter: blur(3px);
  z-index: 20;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: min(360px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  padding: 18px 20px 18px;
  border-radius: 20px;
  background: var(--panel);
  border: 1px solid var(--line);
  box-shadow: 0 12px 40px rgba(120, 80, 50, 0.15);
  animation: rise-in 0.25s ease-out;
}

@keyframes rise-in {
  0% {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

.question {
  margin: 0;
  font-size: 14px;
  line-height: 1.7;
}

.actions button {
  flex: 1;
}

.yes {
  border: none;
  border-radius: 10px;
  padding: 8px 0 7px;
  background: #d9695f;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 0 #b04f47;
  transition: transform 0.1s, box-shadow 0.1s;
}

.yes:active {
  transform: translateY(2px);
  box-shadow: 0 1px 0 #b04f47;
}
